const routes = {
    home: '/',
    login: '/login',
    about: '/about',
    skill: '/skill',
    experience: '/experience',
    projects: '/projects',
    projectDetail: '/projects/:projectId', 
    contact: '/contact',

    test: '/test',
    notfound404: '/*',
};

export default routes;
